"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var core_1 = require("@angular/core");
var common_1 = require("@angular/common");
var AccordionGroup_1 = require("./AccordionGroup");
var Accordion_1 = require("./Accordion");
var AccordionToggle_1 = require("./AccordionToggle");
var AccordionHeading_1 = require("./AccordionHeading");
__export(require("./Accordion"));
__export(require("./AccordionGroup"));
__export(require("./AccordionToggle"));
__export(require("./AccordionHeading"));
var AccordionModule = (function () {
    function AccordionModule() {
    }
    return AccordionModule;
}());
AccordionModule = __decorate([
    core_1.NgModule({
        imports: [
            common_1.CommonModule
        ],
        declarations: [
            Accordion_1.Accordion,
            AccordionGroup_1.AccordionGroup,
            AccordionToggle_1.AccordionToggle,
            AccordionHeading_1.AccordionHeading
        ],
        exports: [
            Accordion_1.Accordion,
            AccordionGroup_1.AccordionGroup,
            AccordionToggle_1.AccordionToggle,
            AccordionHeading_1.AccordionHeading
        ]
    })
], AccordionModule);
exports.AccordionModule = AccordionModule;
